import AddIcon from '@mui/icons-material/Add';
import { Button, Tooltip, Typography } from '@mui/material';

import { fontWeight } from '@verantos-dev/shared-ui-components/tokens';

import type { AnalyticalVariablesControls } from '../types';

// "Variables (N)": the title and count at the top of the dataset's content, in the list
// card and in the grid's toolbar.
export const VariablesTitle = ({ title }: Pick<AnalyticalVariablesControls, 'title'>) => (
  <Typography
    variant="subtitle1"
    component="h3"
    noWrap
    sx={{ fontWeight: fontWeight.semibold }}
    data-testid="analysis-variables-title"
  >
    {title}
  </Typography>
);

// The Analytical dataset's Add variable action, locked with a reason while editing is.
export const AddVariableButton = ({
  addVariableLabel,
  onAddVariable,
  isEditDisabled,
  editLockTooltip,
}: Omit<AnalyticalVariablesControls, 'title'>) => (
  <Tooltip title={editLockTooltip ?? ''} disableHoverListener={!editLockTooltip}>
    {/* span wrapper so the tooltip still shows when the button is disabled */}
    <span>
      <Button
        variant="outlined"
        size="small"
        onClick={onAddVariable}
        disabled={isEditDisabled}
        startIcon={<AddIcon fontSize="small" />}
        sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
        data-testid="analysis-variable-add"
      >
        {addVariableLabel}
      </Button>
    </span>
  </Tooltip>
);
